import { Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import {
    BaseWebApiService,
    WebApiRequestBase,
    WebApiRequest,
    WebApiResponse,
    WebApiResponseBase
} from 'angular-library';

import { Dirette, dataEvento, EventiDirette, Portali, VisitePortale, Assegnazione } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';

@Injectable()
export class DiretteService {
    baseUrl;

    constructor(private baseService: BaseWebApiService) {
        this.baseUrl = baseService.URL_REST_PATH + environment.diretteController;
    }

    getListaDirette(portale: string): Promise<WebApiResponse<Dirette[]>> {
        let request: WebApiRequest<string> = new WebApiRequest<string>();
        request.data = portale;
        return this.baseService.post(this.baseUrl + "lista", request).then(p => {
            let response: WebApiResponse<Dirette[]> = p as WebApiResponse<Dirette[]>;
            return response;
        });
    }

    getDiretta(datiEvento: dataEvento): Promise<WebApiResponse<Dirette>> {
        let request: WebApiRequest<dataEvento> = new WebApiRequest<dataEvento>();
        request.data = datiEvento;
        return this.baseService.post(this.baseUrl + "diretta", request).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    getDirettaPortale(datiEvento: dataEvento): Promise<WebApiResponse<Dirette>> {
        let request: WebApiRequest<dataEvento> = new WebApiRequest<dataEvento>();
        request.data = datiEvento;
        return this.baseService.post(this.baseUrl + "diretta_portale", request, false).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    refreshDirettaPortale(diretta: Dirette): Promise<WebApiResponse<Dirette>> {
        let request: WebApiRequest<Dirette> = new WebApiRequest<Dirette>();
        request.data = diretta;
        return this.baseService.post(this.baseUrl + "refresh", request, false).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    avanzaStato(datiEvento: dataEvento): Promise<WebApiResponse<Dirette>> {
        datiEvento.clientTime = new Date();
        let request: WebApiRequest<dataEvento> = new WebApiRequest<dataEvento>();
        request.data = datiEvento;
        return this.baseService.post(this.baseUrl + "avanza_stato", request).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    saveEvento(evento: EventiDirette): Promise<WebApiResponse<Dirette>> {
        evento.last_modified = new Date();
        let request: WebApiRequest<EventiDirette> = new WebApiRequest<EventiDirette>();
        request.data = evento;
        return this.baseService.post(this.baseUrl + "save_evento", request).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    deleteEvento(evento: EventiDirette): Promise<WebApiResponse<Dirette>> {
        let request: WebApiRequest<EventiDirette> = new WebApiRequest<EventiDirette>();
        request.data = evento;
        return this.baseService.post(this.baseUrl + "delete_evento", request).then(p => {
            let response: WebApiResponse<Dirette> = p as WebApiResponse<Dirette>;
            return response;
        });
    }

    updateDettagli(diretta: Dirette): Promise<WebApiResponseBase> {
        let request: WebApiRequest<Dirette> = new WebApiRequest<Dirette>();
        request.data = diretta;
        return this.baseService.post(this.baseUrl + "update_dettagli", request).then(p => {
            let response: WebApiResponseBase = p as WebApiResponseBase;
            return response;
        });
    }

    getListaPortali(): Promise<WebApiResponse<Portali[]>> {
        return this.baseService.post(this.baseUrl + "portali", new WebApiRequestBase()).then(p => {
            let response: WebApiResponse<Portali[]> = p as WebApiResponse<Portali[]>;
            return response;
        });
    }

    annullaAssegnazione(data: Assegnazione): Promise<WebApiResponseBase> {
        let request: WebApiRequest<Assegnazione> = new WebApiRequest<Assegnazione>();
        request.data = data;
        return this.baseService.post(this.baseUrl + "annulla_assegnazione", request).then(p => {
            let response: WebApiResponseBase = p as WebApiResponseBase;
            return response;
        });
    }

    checkPortale(requestDomain: string): Promise<WebApiResponseBase> {
        let request: WebApiRequest<string> = new WebApiRequest<string>();
        request.data = requestDomain;
        return this.baseService.post(this.baseUrl + "check_portale", request, false).then(p => {
            let response: WebApiResponseBase = p as WebApiResponseBase;
            return response;
        });
    }

    getVisitePortale(portale: string): Promise<WebApiResponse<VisitePortale>> {
        let request: WebApiRequest<string> = new WebApiRequest<string>();
        request.data = portale;
        return this.baseService.post(this.baseUrl + "visite_portale", request).then(p => {
            let response: WebApiResponse<VisitePortale> = p as WebApiResponse<VisitePortale>;
            return response;
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/dirette.service.ts